import { render, staticRenderFns } from "./AthleteComparativeDataCompare.vue?vue&type=template&id=61b72321&scoped=true&"
import script from "./AthleteComparativeDataCompare.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataCompare.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataCompare.vue?vue&type=style&index=0&id=61b72321&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b72321",
  null
  
)

export default component.exports